/* AccountStatsTab — the per-account Stats surface, promoted to its own top-level
   tab in the account view (next to where Access used to sit). It consolidates the
   per-account stats that used to live buried inside other sections:
     • Statistics — the Statistics page for this one account (was Chat assistant
                  → Stats, then the Chat panel)
     • Subs     — new-subscription welcome-sequence funnel (was Automated messages
                  → Statistics → Subscriptions)
     • Online   — online-opener conversion (was Automated messages → Statistics → Online)
   Mass / Priority campaign stats are destined here too but are not built yet. */
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import type { Account } from '../../api/client';
import { SubTabBar } from '../SubTabBar';
import { WelcomeStatsView } from '../AutomatedMessages/StatisticsPanel';
import { OnlineStatsPanel } from '../AutomatedMessages/OnlineStatsPanel';
import { UnifiedStatistics } from './unified/UnifiedStatistics';

interface Props {
  account: Account;
}

export function AccountStatsTab({ account }: Props) {
  const { t } = useTranslation('statistics');
  const { t: tu } = useTranslation('statsUnified');
  const [searchParams, setSearchParams] = useSearchParams();
  const stab = searchParams.get('stab') || 'chat';

  const setStab = (id: string) => {
    const current = Object.fromEntries(searchParams.entries());
    setSearchParams({ ...current, stab: id });
  };

  // Zero-state "go fix it" jumps from the chat panel now have to cross section
  // boundaries: switch the top-level tab back to Chat assistant AND select the
  // sub-tab that closes the gap.
  const openChatSubTab = (id: string) => {
    const current = Object.fromEntries(searchParams.entries());
    setSearchParams({ ...current, tab: 'chat-assistant', sub: id });
  };

  const subTabs = [
    { id: 'chat', label: tu('title'), icon: 'bar-chart-2' },
    { id: 'subs', label: t('tabs.subs'), icon: 'user-plus' },
    { id: 'online', label: t('tabs.online'), icon: 'radio' },
  ];

  return (
    <div>
      <SubTabBar tabs={subTabs} active={stab} onChange={setStab} />

      {stab === 'chat' && <UnifiedStatistics accountId={account.account_id} onOpenSubTab={openChatSubTab} />}
      {stab === 'subs' && <WelcomeStatsView accountId={account.account_id} />}
      {stab === 'online' && <OnlineStatsPanel accountId={account.account_id} />}
    </div>
  );
}
